module.exports = __webpack_public_path__ + "img/chippa-united-logo-icon.7a033084.png";